/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_TitleInputs */

const en_directory_tools_title = /** @type {(inputs: Directory_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product discovery tools`)
};

const zh_directory_tools_title = /** @type {(inputs: Directory_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品发现工具`)
};

/**
* | output |
* | --- |
* | "Product discovery tools" |
*
* @param {Directory_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_title = /** @type {((inputs?: Directory_Tools_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_title(inputs)
	return zh_directory_tools_title(inputs)
});
export { directory_tools_title as "directory.tools.title" }